/* eslint-disable jsx-a11y/anchor-has-content,jsx-a11y/no-noninteractive-element-interactions,react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import {
  selectRequestState,
  selectFieldBlockedUserId,
  selectFieldCausesId,
  selectFieldComment,
  changeFieldBlockedUserId,
  changeFieldCausesId,
  changeFieldComment,
  sendRequestToExecutorList,
  sendRequestAddToCustomerList
} from 'mt-react-common/modules/userBlackList/reducers/static/forms/addUserBlackListForm/reduce';

import WrapperPopUp from 'components/Common/PopUps/WrapperPopUp';
import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import { selectItemById } from 'mt-react-common/common/reducers/objectCollection/reducer';
import OpacityPreLoader from 'components/Common/PreLoaders/OpacityPreLoader';

const addUserBlackListFromRN = 'userBlackList.forms.addUserBlackListForm';

class AddUserBlackListPopUp extends Component {
  componentDidUpdate(prevProps) {
    if (
      prevProps.requestState.hasSuccessQuery !==
        this.props.requestState.hasSuccessQuery &&
      this.props.requestState.hasSuccessQuery
    ) {
      this.props.handleSuccess();
      this.props.handleClose();
    }
  }

  sendRequest = () => {
    this.props.changeFieldBlockedUserId(this.props.blockedUserId);
    if (this.props.categoryId === 1) {
      this.props.sendRequestAddToCustomerList();
    } else if (this.props.categoryId === 2) {
      this.props.sendRequestToExecutorList();
    }
  };

  render() {
    const hasError = fieldErrors => fieldErrors.length > 0;
    const errorDesc = fieldErrors => {
      if (fieldErrors.length > 0) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {fieldErrors[0].message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };

    const getHeaderText = () => {
      if (this.props.categoryId === 1) {
        return (
          <h4 className="modal-title">
            {t('Добавить пользователя {username} в черный список заказчиков', {
              username: this.props.blockedUserInfo.username
            })}
            {``}
          </h4>
        );
      } else if (this.props.categoryId === 2) {
        return (
          <h4 className="modal-title">
            {t(
              'Добавить пользователя {username} в черный список исполнителей',
              { username: this.props.blockedUserInfo.username }
            )}
          </h4>
        );
      }
      return null;
    };

    return (
      <WrapperPopUp {...this.props}>
        <div
          className="modal-dialog modal-gray modal-sm"
          role="document"
          onClick={e => e.stopPropagation()}
        >
          <div className="modal-content">
            <div className="modal-header text-center">
              <a
                href={null}
                onClick={this.props.handleClose}
                className="close close-black"
              />
              <i className="fa fa-exclamation-triangle modal-icon" />
              {getHeaderText()}
              <p>
                {t(
                  'Пожалуйста, сообщите причину, по которой вы хотите добавить пользователя в свой черный список'
                )}
              </p>
            </div>
            <form id="form">
              <div className="modal-body">
                {this.props.requestState.hasInProgress ? (
                  <OpacityPreLoader />
                ) : null}
                <div
                  className={`form-group ${
                    hasError(this.props.fieldCausesId.errors) ? 'has-error' : ''
                  }`}
                >
                  <label htmlFor="form" className="control-label">
                    {t('Причина')}
                  </label>
                  {this.props.userBlackListCauses.map(item => {
                    if (item.category === this.props.categoryId) {
                      return (
                        <div
                          className="control-group"
                          key={`userBlackListCausesId${item.id}`}
                        >
                          <div className="radio abc-radio abc-radio-primary">
                            <input
                              type="radio"
                              id={`userBlackListCausesId-${item.id}`}
                              value={item.id}
                              checked={
                                this.props.fieldCausesId.value ===
                                item.id.toString()
                              }
                              onChange={e => {
                                this.props.changeFieldCausesId(e.target.value);
                              }}
                            />
                            <label htmlFor={`userBlackListCausesId-${item.id}`}>
                              {item.title}
                            </label>
                          </div>
                        </div>
                      );
                    }
                    return null;
                  })}
                  {errorDesc(this.props.fieldCausesId.errors)}
                </div>
                <div
                  className={`form-group m-b-0 ${
                    hasError(this.props.fieldComment.errors) ? 'has-error' : ''
                  }`}
                >
                  <label
                    htmlFor="complaintTextarea"
                    className="col-sm-2 control-label"
                  >
                    {t('Комментарий')}
                  </label>
                  <textarea
                    onChange={e => {
                      this.props.changeFieldComment(e.target.value);
                    }}
                    className="form-control"
                    rows="3"
                    id="complaintTextarea"
                  />
                  {errorDesc(this.props.fieldComment.errors)}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-muted"
                  onClick={this.props.handleClose}
                >
                  {t('Отмена')}
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={this.sendRequest}
                >
                  {t('Заблокировать')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </WrapperPopUp>
    );
  }
}

AddUserBlackListPopUp.defaultProps = {};

AddUserBlackListPopUp.propTypes = {
  // IN
  categoryId: PropTypes.number.isRequired,
  blockedUserId: PropTypes.number.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSuccess: PropTypes.func.isRequired,
  // CONNECT STATE
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    countQueries: PropTypes.number.isRequired,
    hasSuccessQuery: PropTypes.bool
  }).isRequired,
  fieldCausesId: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldBlockedUserId: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldComment: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  userBlackListCauses: PropTypes.arrayOf(PropTypes.shape).isRequired,
  blockedUserInfo: PropTypes.shape({
    username: PropTypes.string.isRequired
  }).isRequired,

  // CONNECT DISPATCH
  changeFieldCausesId: PropTypes.func.isRequired,
  changeFieldBlockedUserId: PropTypes.func.isRequired,
  changeFieldComment: PropTypes.func.isRequired,
  sendRequestAddToCustomerList: PropTypes.func.isRequired,
  sendRequestToExecutorList: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  requestState: selectRequestState(state, addUserBlackListFromRN),
  fieldCausesId: selectFieldCausesId(state, addUserBlackListFromRN),
  fieldBlockedUserId: selectFieldBlockedUserId(state, addUserBlackListFromRN),
  fieldComment: selectFieldComment(state, addUserBlackListFromRN),
  userBlackListCauses: getItemFromRefList(state, 'userBlackListCauses'),

  blockedUserInfo: selectItemById(
    state,
    'usersModule.collections.userCollection',
    props.blockedUserId
  )
});

const mapDispatchToProps = dispatch => ({
  changeFieldCausesId: value =>
    dispatch(changeFieldCausesId(addUserBlackListFromRN, value)),
  changeFieldBlockedUserId: value =>
    dispatch(changeFieldBlockedUserId(addUserBlackListFromRN, value)),
  changeFieldComment: value =>
    dispatch(changeFieldComment(addUserBlackListFromRN, value)),
  sendRequestAddToCustomerList: () =>
    dispatch(sendRequestAddToCustomerList(addUserBlackListFromRN)),
  sendRequestToExecutorList: () =>
    dispatch(sendRequestToExecutorList(addUserBlackListFromRN))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddUserBlackListPopUp);



// WEBPACK FOOTER //
// ./src/components/UserBlackList/AddUserBlackListPopUp/AddUserBlackListPopUp.js